import { Pipe, PipeTransform } from '@angular/core';
import { ContenuSiteService } from '../services/contenu-site.service';
import { LangService } from '../services/lang.service';

// Pipe "impure" comme traduire, mais lit son texte depuis la base de donnees (ContenuSite)
// au lieu du dictionnaire statique -> permet a l'admin de modifier ces textes sans toucher
// au code, via Admin -> "Contenu du site". Utilise pour les paragraphes editoriaux, citations,
// statistiques... (pas pour les labels d'interface comme les boutons, qui restent sur "traduire").
@Pipe({
  name: 'contenu',
  pure: false
})
export class ContenuPipe implements PipeTransform {

  constructor(
    private contenuSiteService: ContenuSiteService,
    private langService: LangService
  ) { }

  transform(cle: string): string {
    const bloc = this.contenuSiteService.obtenir(cle);
    if (!bloc) return '';

    const langue = this.langService.getLangueActuelle();
    if (langue === 'en') return bloc.texteEn || bloc.texteFr;
    if (langue === 'ar') return bloc.texteAr || bloc.texteFr;
    return bloc.texteFr;
  }
}
